module.exports = __webpack_public_path__ + "media/manage/opt-out-5006ce06.png";